exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.screenfull[data-v-b966e418] {\r\n  display: inline-block;\r\n  cursor: pointer;\r\n  vertical-align: -0.15em;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b966e418","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Screenfull/index.vue
// module id = 258
// module chunks = 351